// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserProfileCard_profileContainer__hmTOE {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

.UserProfileCard_profileHeader__M1imp {
  text-align: center;
  margin-bottom: 20px;
}

.UserProfileCard_profilePicture__HYXQt img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.UserProfileCard_profileDetails__CM2aM {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.UserProfileCard_detailsSection__iIMPb {
  flex-basis: 48%;
}

.UserProfileCard_detailItem__wKkRJ {
  display: flex;
  margin-bottom: 10px;
}

.UserProfileCard_detailLabel__crfjZ {
  font-weight: bold;
  margin-right: 10px;
  flex-basis: 30%;
}

.UserProfileCard_detailValue__l\\+XkA {
  flex-basis: 70%;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/components/UserProfileCard/UserProfileCard.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".profileContainer {\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  background-color: #fff;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  border-radius: 5px;\r\n}\r\n\r\n.profileHeader {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.profilePicture img {\r\n  width: 100px;\r\n  height: 100px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.profileDetails {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n}\r\n\r\n.detailsSection {\r\n  flex-basis: 48%;\r\n}\r\n\r\n.detailItem {\r\n  display: flex;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.detailLabel {\r\n  font-weight: bold;\r\n  margin-right: 10px;\r\n  flex-basis: 30%;\r\n}\r\n\r\n.detailValue {\r\n  flex-basis: 70%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileContainer": `UserProfileCard_profileContainer__hmTOE`,
	"profileHeader": `UserProfileCard_profileHeader__M1imp`,
	"profilePicture": `UserProfileCard_profilePicture__HYXQt`,
	"profileDetails": `UserProfileCard_profileDetails__CM2aM`,
	"detailsSection": `UserProfileCard_detailsSection__iIMPb`,
	"detailItem": `UserProfileCard_detailItem__wKkRJ`,
	"detailLabel": `UserProfileCard_detailLabel__crfjZ`,
	"detailValue": `UserProfileCard_detailValue__l+XkA`
};
export default ___CSS_LOADER_EXPORT___;
